// extracted by mini-css-extract-plugin
export var root = "FloatingBanner-module--root--2rj8j";
export var stickToTop = "FloatingBanner-module--stick-to-top--1Pwtm";
export var container = "FloatingBanner-module--container--3cigT";